import React from 'react';
import { ICorrectAccountCategory } from '@/types';

/** AI 借贷组合 解析 */
interface IProps {
    data: ICorrectAccountCategory; // 会计分录题
}

const colors = ['', 'green', 'red', '', '', ''];

const CpaCorrectCategory: React.FC<IProps> = ({ data }) => {
    const { correctAccountList, userScore } = data;

    return (
        <div className="category-father">
            {correctAccountList.map((item, index) => {
                const { borrowList, loanList } = item;
                return (
                    <div key={JSON.stringify(item)}>
                        <div className="category-child-borrow-item category-root">
                            {index === 0 && <div className={`item-score ${userScore > 0 ? 'green-bg' : 'red-bg'}`}>{userScore}分</div>}
                            <div>借:</div>
                            {borrowList && (
                                <div className="child-borrow">
                                    {borrowList.map(childItem => (
                                        <div
                                            className={`borrow-subject ${colors[childItem.correctResult]}`}
                                            key={JSON.stringify(childItem)}
                                        >
                                            <span>{childItem.subjectName}</span>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <span>{childItem.amountNum}</span>
                                        </div>
                                    ))}
                                    {
                                        <div className="category-child-loan-item">
                                            <div className="loan">贷:</div>
                                            <div className="loan-subject-list">
                                                {loanList &&
                                                    loanList.map(childItem => (
                                                        <div
                                                            className={`loan-subject ${colors[childItem.correctResult]}`}
                                                            key={JSON.stringify(childItem)}
                                                        >
                                                            <span>{childItem.subjectName}</span>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            <span>{childItem.amountNum}</span>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default CpaCorrectCategory;
